// Charge le script Calendly uniquement au premier clic — évite les 429 au chargement
let loading = false;
let loaded  = false;
const queue = [];

function flushQueue() {
    queue.forEach(opts => window.Calendly.initPopupWidget(opts));
    queue.length = 0;
}

export function openCalendly(opts = {}) {
    if (loaded && window.Calendly) {
        window.Calendly.initPopupWidget(opts);
        return;
    }
    queue.push(opts);
    if (loading) return;
    loading = true;
    const link = document.createElement("link");
    link.rel  = "stylesheet";
    link.href = "https://assets.calendly.com/assets/external/widget.css";
    document.head.appendChild(link);
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.onload = () => { loaded = true; loading = false; flushQueue(); };
    document.head.appendChild(script);
}
